import { type Registry as Services, service } from '@ember/service';
import BaseRoute from 'uplisting-frontend/pods/base/route';

export default abstract class SidebarBookingsRepliesRoute extends BaseRoute {
  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  @service('repositories/property-tag')
  propertyTagRepository!: Services['repositories/property-tag'];

  @service('repositories/custom-booking-attribute')
  customBookingAttributeRepository!: Services['repositories/custom-booking-attribute'];

  model() {
    return Promise.all([
      this.propertyRepository.findAll(),
      this.propertyTagRepository.findAll(),
      this.customBookingAttributeRepository.findAll(),
    ]);
  }
}
